export const firebaseVzlaEnv = {
  usePublicVapidKey: 'BGU-oC7PIKcChMF30oQQ7I0VP4gea1VJq1aoMssRjZYHTYWgkrTbC9HCTZY_0QOAKQx5UB_7Pgn7GGdpWh-thxA',
  messagingSenderId: '211585366551'
};
